import {Injectable} from '@angular/core';
import {APP_CONFIG} from '../../shared/common/config';
import {HttpClient} from '@angular/common/http';
import {FXResponse} from '../../models/response.model';
import {MapUtils} from '../../shared/utils/mapper';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {standardizeParam} from '../../shared/utils/helper';
import {GroupMamMasterModel, MamApprovalModel, MamFollowerModel} from '../../models/mam.approval.model';
import {IbRequestModel} from '../../models/ib.request.model';

@Injectable({
  providedIn: 'root'
})
export class IbMamService {
  private ibMamUrl = APP_CONFIG.BASE_API_LINK.IB;

  constructor(private http: HttpClient) {}

  getMamPendingMaster(param): Observable<FXResponse<any>> {
    const url = `${this.ibMamUrl}/request-master-mam-accounts/pending?${standardizeParam(param)}`;
    return this.http
      .get(url)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          response.paging = res.data.paging;
          response.data = response.data.mt4_request_mam_master_accounts.map(v =>
            MapUtils.deserialize(MamApprovalModel, v));
          return response;
        }),
      );
  }
  getMamMaster(param): Observable<FXResponse<any>> {
    const url = `${this.ibMamUrl}/master-mam-accounts?${standardizeParam(param)}`;
    return this.http
      .get(url)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          response.paging = res.data.paging;
          response.data = response.data.master_mam_accounts.map(v =>
            MapUtils.deserialize(MamApprovalModel, v));
          return response;
        }),
      );
  }
  getGroupMamMaster(userId): Observable<FXResponse<any>> {
    const url = `${this.ibMamUrl}/ib-groups/${userId}`;
    return this.http
      .get(url)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          response.data = response.data.group_configs.map(v =>
            MapUtils.deserialize(GroupMamMasterModel, v));
          return response;
        }),
      );
  }

  updateGroupMamMaster(item: any): Observable<FXResponse<any>> {
    const url = `${this.ibMamUrl}/ib-groups`;
    return this.http.post(url, item).pipe(
      map((res: any) => {
        const response = new FXResponse<any>().deserialize(res);
        return response;
      })
    );
  }

  updateProcessMamAccount(item: any): Observable<any> {
    const url = `${this.ibMamUrl}/process-request-master-mam-accounts`;
    const jsonBonus = MapUtils.serialize(item);
    return this.http.post(url, jsonBonus).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getIBStandard(param): Observable<FXResponse<any>> {
    const url = `${this.ibMamUrl}/standard-request-ibs?${standardizeParam(param)}`;
    return this.http
      .get(url)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          response.paging = res.data.paging;
          response.data = response.data.ib_requests.map(v =>
            MapUtils.deserialize(IbRequestModel, v));
          return response;
        }),
      );
  }
  updateIBStandard(item: any): Observable<any> {
    const url = `${this.ibMamUrl}/process-standard-request-ibs`;
    const jsonBonus = MapUtils.serialize(item);
    return this.http.post(url, jsonBonus).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getIBOrganic(param): Observable<FXResponse<any>> {
    const url = `${this.ibMamUrl}/organic-request-ibs?${standardizeParam(param)}`;
    return this.http
      .get(url)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          response.paging = res.data.paging;
          response.data = response.data.ib_requests.map(v =>
            MapUtils.deserialize(IbRequestModel, v));
          return response;
        }),
      );
  }
  updateIBOrganic(item: any): Observable<any> {
    const url = `${this.ibMamUrl}/process-organic-request-ibs`;
    const jsonBonus = MapUtils.serialize(item);
    return this.http.post(url, jsonBonus).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  getAccountMamLevel(param): Observable<FXResponse<any>> {
    const url = `${this.ibMamUrl}/master-mam-accounts/level1-ibs?${standardizeParam(param)}`;
    return this.http
      .get(url)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          response.data = res.data.level1_ibs;
          return response;
        }),
      );
  }
  createAccountMamMaster(item: any): Observable<FXResponse<any>> {
    const url = `${this.ibMamUrl}/master-mam-accounts`;
    const body = MapUtils.serialize(item);
    return this.http.post(url, body).pipe(
      map((res: any) => {
        const response = new FXResponse<any>().deserialize(res);
        return response;
      })
    );
  }
  updateRateMamMaster(body): Observable<FXResponse<any[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.IB}/hwm-mam-master`;
    return this.http.patch(url, body).pipe(
      map((res: any) => {
        const response = new FXResponse<any[]>().deserialize(res);
        return response;
      })
    );
  }
  getMamFollowers(params: any): Observable<FXResponse<any>> {
    const url = `${this.ibMamUrl}/mam-followers?${standardizeParam(params)}`;
    return this.http
      .get(url)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          response.paging = res.data.paging;
          response.data = response.data.follower_mam_accounts.map(v =>
            MapUtils.deserialize(MamFollowerModel, v));
          return response;
        }),
      );
  }
  updateMamFollower(item: any): Observable<FXResponse<any>> {
    const url = `${this.ibMamUrl}/mam-followers`;
    const body = MapUtils.serialize(item);
    return this.http.patch(url, body).pipe(
      map((res: any) => {
        const response = new FXResponse<any>().deserialize(res);
        return response;
      })
    );
  }
  processCloseAllPosition(item: any): Observable<FXResponse<any>> {
    const url = `${this.ibMamUrl}/mam-followers/positions/close-all`;
    const body = MapUtils.serialize(item);
    return this.http.post(url, body).pipe(
      map((res: any) => {
        const response = new FXResponse<any>().deserialize(res);
        return response;
      })
    );
  }
}
